import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useGetDocumentPreSignedUrl = () => {
  const {
    data: presignedUrl,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<string>((response) => response);

  const getPresignedUrl = async (documentId: string) => {
    await call(`documents/${documentId}/preSignedUrl`, "GET");
  };

  return { presignedUrl, getPresignedUrl, isLoading, isFailed };
};
